import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cdata:{},//定义数据地图
    typeList1:{},
    typeList2:{},
    typeList3:{},
    typeList4:{},
    region1:'',//地图点击地区
    region2:'',//地图点击地区
    region3:'',//地图点击地区
    region4:'',//地图点击地区
    policy:{},
    carList:{},
    now:'',
    nowIndex:'',
    nowData:'',
    anow:'',
  },
  mutations: {
    setcdata(state,params){
          state.cdata = params
         //外部传过来的值赋值给state里面的cdata
    },
    setypeList1(state,params){
      state.typeList1 = params

    },
    setypeList2(state,params){

      state.typeList2 = params

    },
    setypeList3(state,params){

      state.typeList3 = params

    },
    setypeList4(state,params){

      state.typeList4 = params
    },
    setregion1(state,params){
      state.region1 = params
    },
    setregion2(state,params){
      state.region2 = params
    },
    setregion3(state,params){
      state.region3 = params
    },
    setregion4(state,params){
      state.region4 = params
    },
    setData(state,params){
      state.carList = params
      //外部传过来的值赋值给state里面的cdata
    },
    setpolicy(state,params){
      state.now = params
    },
    setact(state,params){
      state.nowIndex = params
    },
    setdata(state,params){
      state.nowData = params
    },
    set(state,params){
      state.anow = params
    },
  },
  actions: {
  },
  modules: {
  }
})
